$(document).ready(function(){
  var wowSlider = new WowSlider(
    {   effect: "fade",
        prev: "",
        next: "",
        duration: 10*100,
        delay: 20*100,
        outWidth: 958,
        outHeight: 360,
        width: 958,
        height: 360,
        caption: false,
        controls: true,
        autoPlay: false,
        bullets: 0
    });

  $('nav.main ul li a').textShadow({
    x:      -1, 
    y:      -1, 
    radius: 3,
    color:  "#267e72"
  });

  initPhotoCaroussel();
});

var caroussel_photos = [];
var caroussel_title = '';

function initPhotoCaroussel() {
    // First photo
	$("#image-feature").append($(".images ul li:first-child img").clone()).hide().fadeIn('slow');
	
	$(".images ul li img").each(function() {	
		caroussel_photos.push([$(this).attr('src'), caroussel_title]);
	});
	
	$("#image-feature").click(function(e) {
		var index = 0;
		
		for(; index < caroussel_photos.length; index++) {
			if(caroussel_photos[index][0] == $(this).find('img').attr('src'))
				break;
		}

		// jQuery.slimbox(caroussel_photos, index);
	});
	
	// Functionality
	$(".images ul li").click(function(e){
		e.preventDefault();
			
		// Old photo
		$("#image-feature img:first-child").delay(200).fadeOut('slow', function() {
			$(this).remove();
		});

		// New photo
		$("#image-feature").prepend($(this).find("img").clone().hide().fadeIn('slow'));
			
		return false;
	});
}

